export enum RangeModeTypes {
  Day = "day",
  Week = "week",
  TwoWeeks = "2weeks",
  Month = "month",
  Quarter = "quarter",
  Custom = "custom"
}
